import { useQuery } from "@tanstack/react-query";

import { useGetPermissions } from "Flocknote/API/queries";

import { getSignupsList } from "NavBar/SignupsAndEvents/API//fetch";
import { signupsListKeys } from "NavBar/SignupsAndEvents/API/keys";

// Fires before permissions load so authorized users get data ASAP. If the
// user turns out to lack signups access, the single pre-permissions request
// may fail — retry is 0 until permissions arrive to avoid wasted retries.
// Once permissions resolve, enabled flips to false for unauthorized users.
export const useGetSignupsList = () => {
  const { data: permissions } = useGetPermissions();
  return useQuery({
    queryKey: signupsListKeys.signupsList(),
    queryFn: getSignupsList,
    enabled: !permissions || Boolean(permissions.canSeeSignupsNav),
    retry: permissions ? undefined : 0,
  });
};